import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
    AuthorizationFrontendCallbackLoginComponent,
} from './components/callback-login/authorizationfrontend-callback-login.component';
import {
    AuthorizationFrontendCallbackLogoutComponent
} from './components/callback-logout/authorizationfrontend-callback-logout.component';

const routes: Routes = [
    {
      path: "",
      children:
        [
            {
                path: "callback/login",
                component: AuthorizationFrontendCallbackLoginComponent
            },
            {
                path: "callback/logout",
                component: AuthorizationFrontendCallbackLogoutComponent
            },
        ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthorizationFrontendRoutingModule
{
}

